export default defineNuxtRouteMiddleware(() => {
  const config = useRuntimeConfig()

  if (!config.public.SIGNUP_ENABLED) {
    return navigateTo({ name: 'login' }, { replace: true })
  }

  return null
})
